import { render, staticRenderFns } from "./AppUpButton.vue?vue&type=template&id=1372a48a"
import script from "./AppUpButton.vue?vue&type=script&lang=js"
export * from "./AppUpButton.vue?vue&type=script&lang=js"
import style0 from "./AppUpButton.vue?vue&type=style&index=0&id=1372a48a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports